import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/acc-pay-illustration-modal.svg'


const _withScopeId = n => (_pushScopeId("data-v-42caa74a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["dsf_title", "dsf_confirm_text", "dsf_cancel_text", "dsf_confirm_disabled"]
const _hoisted_2 = { class: "acc-pay-modal__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "acc-pay-modal__illustration",
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "acc-pay-modal__lead" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dsf-icon", {
  dsf_name: "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='8' fill='%23CCF0CE'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.628 5.20553C11.7907 5.36825 11.7907 5.63207 11.628 5.79479L7.04463 10.3781C6.88191 10.5408 6.61809 10.5408 6.45537 10.3781L4.37204 8.29479C4.20932 8.13207 4.20932 7.86825 4.37204 7.70553C4.53476 7.54282 4.79858 7.54282 4.96129 7.70553L6.75 9.49424L11.0387 5.20553C11.2014 5.04282 11.4652 5.04282 11.628 5.20553Z' fill='%23212529'/%3E%3C/svg%3E",
  dsf_size: "16px"
}, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dsf-icon", {
  dsf_name: "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='8' fill='%23CCF0CE'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.628 5.20553C11.7907 5.36825 11.7907 5.63207 11.628 5.79479L7.04463 10.3781C6.88191 10.5408 6.61809 10.5408 6.45537 10.3781L4.37204 8.29479C4.20932 8.13207 4.20932 7.86825 4.37204 7.70553C4.53476 7.54282 4.79858 7.54282 4.96129 7.70553L6.75 9.49424L11.0387 5.20553C11.2014 5.04282 11.4652 5.04282 11.628 5.20553Z' fill='%23212529'/%3E%3C/svg%3E",
  dsf_size: "16px"
}, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "acc-pay-modal__note" }
const _hoisted_9 = ["dsf_checked", "dsf_label"]
const _hoisted_10 = { class: "acc-pay-modal__note acc-pay-modal__reversal_note" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccPayModal',
  emits: ["close", "not-now", "activate"],
  setup(__props, { emit }) {



const hasAcceptedTerms = ref(false)

const onClose = () => emit('close')
const onNotNow = () => emit('not-now')

const onActivate = () => {
  if (!hasAcceptedTerms.value) return
  emit('activate')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-modal", {
    dsf_open: true,
    dsf_title: _ctx.$t('acc_pay.modal.title'),
    dsf_confirm_text: _ctx.$t('acc_pay.modal.activate'),
    dsf_cancel_text: _ctx.$t('acc_pay.modal.not_now'),
    dsf_confirm_disabled: !hasAcceptedTerms.value,
    onClose: onClose,
    onConfirm: onActivate,
    onCancel: onNotNow
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('acc_pay.modal.lead')), 1 /* TEXT */),
      _createElementVNode("ul", {
        class: "acc-pay-modal__benefits",
        "aria-label": _ctx.$t('acc_pay.modal.benefits_label')
      }, [
        _createElementVNode("li", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('acc_pay.modal.benefit_1')), 1 /* TEXT */)
        ]),
        _createElementVNode("li", null, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('acc_pay.modal.benefit_2')), 1 /* TEXT */)
        ])
      ], 8 /* PROPS */, _hoisted_5),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('acc_pay.modal.note')), 1 /* TEXT */),
      _createElementVNode("dsf-checkbox", {
        class: "acc-pay-modal__consent",
        dsf_checked: hasAcceptedTerms.value,
        dsf_label: _ctx.$t('acc_pay.modal.consent'),
        dsf_size: "medium",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (hasAcceptedTerms.value = ($event as CustomEvent<boolean>).detail))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('acc_pay.modal.note_reversal')), 1 /* TEXT */)
    ])
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})